import PartnerSignUp from "./PartnerSignUp";

export default PartnerSignUp;
